module.exports = __webpack_public_path__ + "img/shape-1.6bc9eaab.png";